<div *ngIf="colOffset" class="row my-2">
  <div [class]="colOffset+' shadow bg-white rounded'">
    <div class="row">
      <div *ngIf="title" class="offset-4 col-4 text-center">
        <app-title [title]="title" priority="3" underline [uppercase]="false"></app-title>
      </div>
      <div [class]="(innerOffset?'offset-1 col-10':'col-12')+' py-3'">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
